var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9.22733333px",
    height: "11.3326667px",
    viewBox: "0 0 9.22733333 11.3326667",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/business-S") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hotelcard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Theme/Business",
    transform: "translate(-11.381333, -11.398000)",
    fill: "#00A1DE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/business-S",
    transform: "translate(11.381333, 11.398000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.61533333,4 C5.71990283,4 6.61533333,3.1045695 6.61533333,2 C6.61533333,0.8954305 5.71990283,-1.77635684e-15 4.61533333,-1.77635684e-15 C3.51076383,-1.77635684e-15 2.61533333,0.8954305 2.61533333,2 C2.61533333,3.1045695 3.51076383,4 4.61533333,4 Z M8.23466667,6 L6.73533333,6 L5.612,8.754 L5.118,7.142 L5.51266667,6 L3.73333333,6 L4.12733333,7.14066667 L3.64666667,8.756 L2.51666667,5.99933333 L0.99,5.99933333 L1.77635684e-15,9.47266667 C1.19866667,10.626 2.82533333,11.3326667 4.61533333,11.3326667 C6.40466667,11.3326667 8.03066667,10.626 9.22733333,9.47933333 L8.23466667,6 Z",
    id: "Combined-Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/Business.6ded00a963c90cfca10c7b5574323b4b.svg";
export { ForwardRef as ReactComponent };